import { Directive, input } from '@angular/core';

import { BaseIconDirective } from './base-icon.directive';
import { NavigationIconsType } from './navigations';

@Directive({
  selector: 'svg[dmcomUseNavigationIcon]',
  standalone: true,
})
export class UseNavigationIconDirective extends BaseIconDirective {
  public readonly dmcomUseNavigationIcon = input.required<NavigationIconsType>();
  readonly BASE_PATH = '/assets/ui-components/navigations.sprites.svg';

  public get icon() {
    return this.dmcomUseNavigationIcon();
  }
}
